module.exports = __webpack_public_path__ + "9e3f0f16d67d571bb886ea7bd00b4705.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/unicorn-crown.png
// module id = 2341
// module chunks = 0